import type { SxProps, Theme } from "@mui/material";

export const selectorAutocompleteStyle: SxProps<Theme> = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    height: "50px",
    gap: 2,
    alignSelf: "stretch",
    border: "none",
    borderRadius: "12px",
    backgroundColor: "var(--Base-24, #F4F4F4)",
    "& .MuiOutlinedInput-root": {
        "& fieldset": { border: "none" },
        "&:hover fieldset": { border: "none" },
        "&.Mui-focused fieldset": { border: "none" },
        // The disabled state was the only literal left in this file, so a
        // disabled selector (e.g. "Select a brand first") stayed white on the
        // dark canvas while its enabled sibling flipped correctly.
        "&.Mui-disabled": {
            backgroundColor: "var(--surface-2)",
            "& .MuiInputBase-input": {
                color: "var(--muted) !important",
                "-webkit-text-fill-color": "var(--muted) !important",
            },
            "& .MuiInputBase-input::placeholder": {
                color: "var(--muted) !important",
                "-webkit-text-fill-color": "var(--muted) !important",
            },
        },
    },
    "& .MuiInputBase-input::placeholder": {
        color: "var(--Base-300, #B0B0B0)",
        fontFamily: "CircularStd",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: 450,
        lineHeight: "normal",
    },
    "& .MuiInputBase-input": {
        color: "var(--Base-1000, #000)",
        fontFamily: "CircularStd",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "normal",
    },
    "& .MuiInputBase-input:focus": {
        outline: "none",
        boxShadow: "none",
        border: "none",
    },
    "& .MuiInputBase-input:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0px 1000px var(--Base-24, #F4F4F4) inset !important",
        backgroundColor: "var(--Base-24, #F4F4F4) !important",
        color: "var(--Base-1000, #000) !important",
        border: "none !important",
        transition: "background-color 5000s ease-in-out 0s",
    },
    "& .MuiAutocomplete-clearIndicator": {
        opacity: "1 !important",
        visibility: "visible !important",
    },
};
